// @ts-check

// Ik heb eigenlijk geen idee waarom dit zo is opgelost, maar het werkt en het is de moeite van het aanpassen niet waard
const getStars = (stars) => {
  let starsArr = [];
  if (stars) {
    if (stars.oneStars) {
      starsArr.push(1);
    }
    if (stars.twoStars) {
      starsArr.push(2);
    }
    if (stars.threeStars) {
      starsArr.push(3);
    }
    if (stars.fourStars) {
      starsArr.push(4);
    }
    if (stars.fiveStars) {
      starsArr.push(5);
    }
  }
  return starsArr;
};
const getReviewScore = (score) => {
  // 1. Create an empty array called reviewScoreArr
  const reviewScoreArr = [];

  // 2. If the score object exists, check each key to see if it is true
  // and if it is, add the corresponding number to the array
  if (score) {
    if (score.five) {
      reviewScoreArr.push(5);
    }
    if (score.six) {
      reviewScoreArr.push(6);
    }
    if (score.seven) {
      reviewScoreArr.push(7);
    }
    if (score.eight) {
      reviewScoreArr.push(8);
    }
    if (score.nine) {
      reviewScoreArr.push(9);
    }
  }

  // 3. Return the completed array
  return reviewScoreArr;
};

const normalizeAmenity = (value) => {
  return String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();
};

const PRIME_AMENITY_MATCHERS = {
  gym: [
    "fitness facilities",
    "fitness facilities (surcharge)",
    "fitness classes on site",
    "health club",
    "24-hour fitness facilities",
    "24-hour health club",
    "free use of nearby fitness center",
    "use of nearby fitness center (discount)",
    "fitnessfaciliteiten",
    "fitnessfaciliteiten (toeslag)",
    "fitnesslessen ter plaatse",
    "healthclub",
    "24-uurs fitnessfaciliteiten",
    "24-uurs healthclub",
    "gratis gebruik van fitnesscentrum in de buurt",
    "gebruik van fitnesscentrum in de buurt (korting)"
  ],
  swimming_pool: [
    "swimming pool",
    "indoor/outdoor pool",
    "exercise/lap pool",
    "infinity pool",
    "natural pool",
    "rooftop pool",
    "outdoor seasonal pool",
    "shared/communal pool",
    "children's pool",
    "24-hour pool access",
    "access to nearby indoor pool",
    "access to nearby outdoor pool",
    "number of indoor pools",
    "number of outdoor pools",
    "wheelchair-accessible pool",
    "zwembad",
    "binnen/buitenzwembad",
    "sportzwembad",
    "zwemvijver",
    "zwembad op het dak",
    "seizoensgebonden buitenzwembad",
    "gemeenschappelijk/openbaar zwembad",
    "kinderzwembad",
    "24-uurs toegang tot het zwembad",
    "toegang tot binnenzwembad in de buurt",
    "toegang tot buitenzwembad in de buurt",
    "aantal binnenzwembaden",
    "aantal buitenzwembaden",
    "rolstoeltoegankelijk zwembad"
  ],
  casino: [
    "casino",
    "casino nearby",
    "casino floor size",
    "number of gaming tables",
    "number of slot machines",
    "number of vip gaming rooms",
    "pachinko",
    "bingo",
    "sportsbook",
    "casino in de omgeving",
    "oppervlakte van casino",
    "aantal speltafels",
    "aantal gokautomaten",
    "aantal vip-gamekamers",
    "sportwedkantoor"
  ],
  free_airport_transfer: [
    "free airport transportation",
    "free airport transportation - drop-off",
    "free airport transportation - pickup",
    "gratis vervoer van/naar de luchthaven",
    "gratis vervoer vanaf de luchthaven",
    "gratis vervoer naar de luchthaven"
  ],
  parking: [
    "parking onsite",
    "parking (limited spaces)",
    "covered parking",
    "uncovered parking",
    "secured parking",
    "off-street parking",
    "street parking",
    "self parking (surcharge)",
    "valet parking (surcharge)",
    "free self parking",
    "free valet parking",
    "free parking nearby",
    "free long-term parking",
    "long-term parking",
    "long-term parking (surcharge)",
    "free rv, bus, truck parking",
    "rv, bus, truck parking",
    "rv, bus, truck parking (surcharge)",
    "motorcycle parking only",
    "garage",
    "carport",
    "parkeren ter plaatse",
    "parkeren (beperkt aantal plaatsen)",
    "overdekte parkeerplaatsen",
    "parkeerplaatsen buiten",
    "beveiligde parkeerplaatsen",
    "eigen parkeergelegenheid",
    "parkeerplaatsen in de straat",
    "zelf parkeren (toeslag)",
    "valetparkeren (toeslag)",
    "gratis zelf parkeren",
    "gratis valetparkeren",
    "gratis parkeerplaatsen in de buurt",
    "gratis lang parkeren",
    "lang parkeren",
    "lang parkeren (toeslag)",
    "gratis parkeerplaatsen voor campers / bussen / vrachtwagens",
    "parkeerplaatsen voor campers / bussen / vrachtwagens",
    "parkeerplaatsen voor campers / bussen / vrachtwagens (toeslag)",
    "uitsluitend een parkeerplaats voor motorfietsen"
  ],
  water_park: [
    "water park",
    "water park access (surcharge)",
    "free water park access",
    "waterslide",
    "lazy river",
    "splash pad",
    "inflatable splash pad",
    "waterpark",
    "toegang tot waterpark (toeslag)",
    "gratis toegang tot waterpark",
    "waterglijbaan",
    "lazy river'-waterbaan",
    "waterspeeltuin",
    "opblaasbare waterspeeltuin"
  ],
  wifi: [
    "internet access",
    "internet access - wireless",
    "internet access in public areas - high speed",
    "internet access in public areas - surcharge",
    "wifi (surcharge)",
    "wired internet access - surcharge",
    "internet",
    "wifi (toeslag)",
    "kabelinternet (toeslag)",
    "snel internet in gemeenschappelijke ruimtes",
    "internet in gemeenschappelijke ruimtes (toeslag)"
  ],
  dry_cleaning_laundry: [
    "dry cleaning/laundry service",
    "laundry facilities",
    "coin laundry on site",
    "stomerij / wasserijservice",
    "wasserij",
    "wasserette met muntsysteem ter plaatse"
  ],
  spa_services: [
    "spa services on site",
    "spa treatment room",
    "full-service spa",
    "sauna",
    "steam room",
    "turkish bath/hammam",
    "wheelchair-accessible spa",
    "spaservices ter plaatse",
    "spabehandelingsruimte",
    "volledig uitgeruste spa",
    "stoombad",
    "turks bad / hammam",
    "rolstoeltoegankelijke spa"
  ],
  free_breakfast: [
    "free breakfast",
    "free breakfast (local cuisine)",
    "free breakfast to go",
    "free buffet breakfast",
    "free continental breakfast",
    "free cooked-to-order breakfast",
    "free english breakfast",
    "free full breakfast",
    "free cantonese breakfast",
    "free japanese breakfast",
    "free korean breakfast",
    "free taiwanese breakfast",
    "free self-serve breakfast",
    "children eat free breakfast",
    "gratis ontbijt",
    "gratis ontbijt (lokale gerechten)",
    "gratis ontbijt voor onderweg",
    "gratis ontbijtbuffet",
    "gratis continentaal ontbijt",
    "gratis a-la-carte-ontbijt",
    "gratis engels ontbijt",
    "gratis uitgebreid ontbijt",
    "gratis kantonees ontbijt",
    "gratis japans ontbijt",
    "gratis koreaans ontbijt",
    "gratis taiwanees ontbijt",
    "gratis eenvoudig ontbijtbuffet",
    "gratis ontbijt voor kinderen"
  ],
  accessible_wheelchair: [
    "wheelchair accessible",
    "wheelchair accessible (may have limitations)",
    "wheelchairs available on site",
    "wheelchair-accessible public washroom",
    "wheelchair-accessible concierge desk",
    "wheelchair-accessible path to elevator",
    "wheelchair-accessible registration desk",
    "wheelchair-accessible on-site restaurant",
    "wheelchair-accessible lounge",
    "valet for wheelchair-equipped vehicle",
    "rolstoeltoegankelijk",
    "rolstoeltoegankelijk (mogelijk beperkt)",
    "rolstoelen ter plaatse beschikbaar",
    "rolstoeltoegankelijk openbaar toilet",
    "rolstoeltoegankelijke conciergeb",
    "rolstoeltoegankelijk pad naar lift",
    "rolstoeltoegankelijke registratiebalie",
    "rolstoeltoegankelijk restaurant ter plaatse",
    "rolstoeltoegankelijke lounge",
    "valetparkeren voor voertuigen met een rolstoel"
  ],
  accessibility: [
    "assistive listening devices available",
    "assistive listening devices in meeting rooms",
    "braille or raised signage",
    "visual alarms in hallways",
    "handrails in hallways",
    "handrails in stairways",
    "sign language-capable staff",
    "stair-free path to entrance",
    "well-lit path to entrance",
    "wheelchair accessible path of travel",
    "front entrance ramp",
    "luisterhulpmiddelen beschikbaar",
    "luisterhulpmiddelen in vergaderruimtes",
    "informatieborden in braille of reliefletters",
    "visuele alarmen in de gangen",
    "handleuningen in de gangen",
    "trapleuningen",
    "personeel dat gebarentaal kent",
    "pad zonder trede naar de ingang",
    "goed verlicht pad naar de ingang",
    "rolstoeltoegankelijke paden",
    "helling bij de hoofdingang"
  ],
  accessible_parking: [
    "wheelchair accessible parking",
    "wheelchair-accessible van parking",
    "number of accessible parking spaces",
    "rolstoeltoegankelijke parkeerplaatsen",
    "rolstoeltoegankelijke parkeerplaats personenbus",
    "aantal rolstoeltoegankelijke parkeerplaatsen"
  ],
  electric_charging_station: [
    "electric car charging station",
    "electric bicycle charging station",
    "oplaadpunt voor elektrische auto's",
    "oplaadpunt voor elektrische fietsen"
  ],
  airport_transfer: [
    "airport transportation",
    "airport transportation (surcharge)",
    "airport transportation - drop-off (surcharge)",
    "airport transportation - pickup (surcharge)",
    "luchthaventransport",
    "vervoer van/naar de luchthaven (toeslag)",
    "vervoer vanaf de luchthaven (toeslag)",
    "vervoer naar de luchthaven (toeslag)"
  ],
  meeting_facility: [
    "meeting rooms",
    "number of meeting rooms",
    "conference center",
    "conference space",
    "conference space size (feet)",
    "conference space size (meters)",
    "business center",
    "24-hour business center",
    "ballroom",
    "banquet hall",
    "reception hall",
    "wheelchair-accessible meeting spaces/business center",
    "vergaderruimtes",
    "aantal vergaderruimtes",
    "conferentiecentrum",
    "conferentieruimte",
    "afmetingen conferentieruimte",
    "businesscentrum",
    "24-uurs businesscentrum",
    "balzaal",
    "feestruimte",
    "receptieruimte",
    "rolstoeltoegankelijke vergaderruimten/businesscentrum"
  ],
  free_wifi: [
    "free wifi",
    "free wifi (limited)",
    "free wired internet",
    "gratis wifi",
    "gratis wifi (beperkt",
    "gratis wifi (tijdelijke)",
    "gratis kabelinternet"
  ],
  restaurant: [
    "number of restaurants",
    "wheelchair-accessible on-site restaurant",
    "restaurant",
    "aantal restaurants",
    "rolstoeltoegankelijk restaurant ter plaatse"
  ],
  bar: [
    "number of bars/lounges",
    "number of poolside bars",
    "number of beach bars",
    "number of swim-up bars",
    "number of coffee shops/cafes",
    "snack bar/deli",
    "aantal bars / lounges",
    "aantal poolbars",
    "aantal strandbars",
    "aantal swim-up bars",
    "aantal koffiebars",
    "snackbar / deli"
  ],
  front_desk_24h: ["24-hour front desk", "24-uurs receptie"],
  kitchen: [
    "kitchen",
    "kitchenette",
    "full kitchen",
    "keuken",
    "kitchenette",
    "volledige keuken"
  ],
  air_conditioning: [
    "air conditioning",
    "air conditioning (climate-controlled)",
    "individually controlled air conditioning",
    "airconditioning",
    "individueel regelbare airconditioning"
  ],
  room_service: [
    "room service",
    "room service (limited hours)",
    "24-hour room service",
    "roomservice",
    "roomservice (beperkte uren)",
    "24-uurs roomservice"
  ],
  living_area: [
    "living area",
    "living room",
    "separate living room",
    "sitting area",
    "lounge",
    "woonkamer",
    "aparte woonkamer",
    "zithoek"
  ]
};

const shouldSkipAmenityValue = (amenity) => {
  return !amenity || amenity.startsWith("geen ") || amenity.startsWith("no ");
};

const matchesPrimeAmenity = (amenity, rawAmenities) => {
  if (rawAmenities.includes(amenity.name)) {
    return true;
  }

  const matchers = PRIME_AMENITY_MATCHERS[amenity.name] || [];

  return rawAmenities.some((rawAmenity) => {
    if (shouldSkipAmenityValue(rawAmenity)) {
      return false;
    }

    if (
      amenity.name === "airport_transfer" &&
      (rawAmenity.includes("gratis") || rawAmenity.includes("free "))
    ) {
      return false;
    }

    if (
      amenity.name === "wifi" &&
      (rawAmenity.includes("gratis wifi") || rawAmenity.includes("free wifi"))
    ) {
      return false;
    }

    return matchers.some((matcher) => rawAmenity.includes(matcher));
  });
};

const getAvailablePrimeAmenities = (amenities = []) => {
  const normalizedAmenities = (amenities || [])
    .map((amenity) => normalizeAmenity(amenity))
    .filter(Boolean);

  return getPrimeAmenities().filter((amenity) =>
    matchesPrimeAmenity(amenity, normalizedAmenities)
  );
};

// Dit zijn de prime amenities die we willen laten zien in het overzicht.
const getPrimeAmenities = () => {
  const amenities = [
    {
      name: "gym",
      icon: "fa-solid fa-dumbbell"
    },
    {
      name: "swimming_pool",
      icon: "fa-solid fa-water-ladder"
    },
    {
      name: "casino",
      icon: "fa-solid fa-dice"
    },
    {
      name: "free_airport_transfer",
      icon: "fa-solid fa-plane-departure"
    },
    {
      name: "parking",
      icon: "fa-solid fa-parking"
    },
    {
      name: "water_park",
      icon: "fa-solid fa-water-ladder"
    },
    {
      name: "wifi",
      icon: "fa-solid fa-wifi"
    },
    {
      name: "dry_cleaning_laundry",
      icon: "fa-solid fa-jug-detergent"
    },
    {
      name: "spa_services",
      icon: "fa-solid fa-spa"
    },
    {
      name: "free_breakfast",
      icon: "fa-solid fa-bread-slice"
    },
    {
      name: "accessible_wheelchair",
      icon: "fa-solid fa-wheelchair"
    },
    {
      name: "accessibility",
      icon: "fa-solid fa-universal-access"
    },
    {
      name: "accessible_parking",
      icon: "fa-solid fa-square-parking"
    },
    {
      name: "electric_charging_station",
      icon: "fa-solid fa-charging-station"
    },
    {
      name: "airport_transfer",
      icon: "fa-solid fa-plane-departure"
    },
    {
      name: "meeting_facility",
      icon: "fa-solid fa-people-group"
    },
    {
      name: "free_wifi",
      icon: "fa-solid fa-wifi"
    },
    {
      name: "restaurant",
      icon: "fa-solid fa-utensils"
    },
    {
      name: "bar",
      icon: "fa-solid fa-martini-glass-citrus"
    },
    {
      name: "front_desk_24h",
      icon: "fa-solid fa-bell-concierge"
    },
    {
      name: "kitchen",
      icon: "fa-solid fa-kitchen-set"
    },
    {
      name: "air_conditioning",
      icon: "fa-solid fa-snowflake"
    },
    {
      name: "room_service",
      icon: "fa-solid fa-concierge-bell"
    },
    {
      name: "living_area",
      icon: "fa-solid fa-couch"
    }
  ];

  return amenities;
};
export default {
  getStars,
  getReviewScore,
  getPrimeAmenities,
  getAvailablePrimeAmenities
};
